import {
  PUBLIC_BROKER_REQUEST,
  PUBLIC_BROKER_SUCCESS,
  PUBLIC_BROKER_FAIL,
  UPDATE_PROPERTY_ID,
  PUBLIC_PROPERTY_INFO_REQUEST,
  PUBLIC_PROPERTY_INFO_SUCCESS,
  PUBLIC_PROPERTY_INFO_FAIL,
  PHASE_INFORMATION_REQUEST,
  PHASE_INFORMATION_FAIL,
  PHASE_INFORMATION_SUCCESS,
  APPLICATION_UPDATE_SUCCESS,
  APPLICATION_UPDATE_FAIL,
  APPLICATION_UPDATE_REQUEST,
  CLEAR_FLOW_ERRORS,
  APPLICATION_PROFILE_REQUEST,
  APPLICATION_PROFILE_SUCCESS,
  APPLICATION_PROFILE_FAIL,
  RESET_FLOW,
} from '../actions/FlowAction'
import { LOGOUT_USER } from '../actions/AuthAction'
import { getRandomString } from '../utils/generator'
import { dump } from '../services/debugService'

const initState = {
  property: {},
  step: 0,
  completedAt: null,
  application: {
    id: null,
    userId: null,
    contacts: [
      {
        uid: getRandomString(),
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        documents: [],
        isGuarantor: false,
        income: [],
        hasReleventIncome: true,
      },
    ],
    residents: [
      {
        id: 'INTAKE_RESIDENT_ADULTS',
        value: 1,
      },
      {
        id: 'INTAKE_RESIDENT_CHILDREN',
        value: 0,
      },
    ],
    dateOfOccupancy: '',
    reasonForRent: '',
    currentResidenceAddress: {},
    currentResidenceType: '',
    currentResidenceRentPrice: '',
    currentResidenceDuration: '',
    currentResidenceOwner: {
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      canContact: false,
    },
    remarks: '',
    applicationConfirmationEmail: false,
    finishedStep: {},
  },
}

export default (state = initState, action) => {
  const {
    broker,
    property,
    type,
    application = {},
    applicationProfileError,
    phaseInformationError,
    propertyInfoId,
  } = action

  switch (type) {
    case PUBLIC_BROKER_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      })
    case PUBLIC_BROKER_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        broker: {
          ...state.broker,
          ...broker,
        },
        // brokerSuccess: true,
        // brokerFail: false,
      })
    case PUBLIC_BROKER_FAIL:
      return Object.assign({}, state, {
        fetching: false,
        broker: {
          ...state.broker,
          ...broker,
        },
        // brokerSuccess: false,
        // brokerFail: true,
      })
    case UPDATE_PROPERTY_ID:
      dump({ UPDATE_PROPERTY_ID: propertyInfoId })
      return Object.assign({}, state, {
        propertyInfoId,
      })
    case PUBLIC_PROPERTY_INFO_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        propertyFail: false,
      })
    case PUBLIC_PROPERTY_INFO_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        property: {
          ...state.property,
          ...property,
        },
        propertySuccess: true,
        propertyFail: false,
      })
    case PUBLIC_PROPERTY_INFO_FAIL:
      return Object.assign({}, state, {
        fetching: false,
        property: {
          ...state.property,
          ...property,
        },
        propertySuccess: false,
        propertyFail: true,
      })
    case PHASE_INFORMATION_SUCCESS:
      dump({ action })
      return Object.assign({}, state, {
        fetching: false,
        step: action.step,
        completedAt: action.completedAt,
        phaseInformationError: phaseInformationError,
      })
    case PHASE_INFORMATION_FAIL:
      return Object.assign({}, state, {
        fetching: false,
        phaseInformationError: phaseInformationError,
      })
    case PHASE_INFORMATION_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        phaseInformationError: undefined,
      })
    case APPLICATION_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        application: {
          ...state.application,
          ...application,
        },
      })
    case APPLICATION_UPDATE_FAIL:
      return Object.assign({}, state, {
        fetching: false,
      })
    case APPLICATION_UPDATE_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      })
    case APPLICATION_PROFILE_SUCCESS:
      dump({ application })

      return Object.assign({}, state, {
        fetching: false,
        applicationProfileSuccess: true,
        application: {
          ...state.application,
          ...application,
        },
        applicationProfileError: applicationProfileError,
      })
    case APPLICATION_PROFILE_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        applicationProfileError: undefined,
      })
    case APPLICATION_PROFILE_FAIL:
      return Object.assign({}, state, {
        applicationProfileError: applicationProfileError,
        applicationProfileSuccess: false,
      })
    case CLEAR_FLOW_ERRORS:
      return Object.assign({}, state, {
        phaseInformationError: undefined,
        error: undefined,
        propertyFail: undefined,
        propertySuccess: undefined,
        applicationProfileSuccess: undefined,
        applicationProfileError: undefined,
      })
    case LOGOUT_USER:
    case RESET_FLOW:
      return initState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FlowReducer.js